import { render, staticRenderFns } from "./TreeDialog.vue?vue&type=template&id=aed23afc&scoped=true"
import script from "./TreeDialog.ts?vue&type=script&lang=ts&external"
export * from "./TreeDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./TreeDialog.vue?vue&type=style&index=0&id=aed23afc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed23afc",
  null
  
)

export default component.exports